import { render } from "./WorksOption.vue?vue&type=template&id=7c188f40&scoped=true"
import script from "./WorksOption.vue?vue&type=script&lang=js"
export * from "./WorksOption.vue?vue&type=script&lang=js"

import "./WorksOption.vue?vue&type=style&index=0&id=7c188f40&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c188f40"]])

export default __exports__